<template lang="pug">
.container.cardGeral
  .content-processos
    .processos-main
      .busca-processos
        search-processos(
          @search="search",
          @input="simpleSearchAsync",
          @advancedInput="advancedSearchAsync",
          @advancedSearch="advancedSearch",
          @clear="clear"
        )
      .listagem-processos
        listagem-processos-credenciado(
          titulo="Processos existentes"
          :loading="loading",
          :isBusca="isBusca",
          :processos="processos"
          :isCentral="false"
          @carregaProcessos="carregaProcessos",
          @sort="sort",
          @goTo="goTo"
          @vincular="openModalVincular"
          @alterar="openModalAlteracao"
        )
          app-paginacao(
            :total="totalProcessos",
            :pagina="filtro.pagina",
            @changePage="changePage"
          )
  app-modal.modalVistoriador(
    v-if="showModalVincular",
    :titulo="isAlteracao ? 'Alterar Vistoriador Credenciado' : 'Vincular Vistoriador Credenciado'",
    :width="600"
    @closeModal="closeModal"
  )
    template(slot="body")
      app-label(label="CPF do Vistoriador:")
      el-input(
        v-model="cpfVistoriador"
        clearable
        v-mask="'###.###.###-##'"
        @input="findVistoriador"
      )
      div.nome-vistoriador(v-if="nomeVistoriador")
        app-label(label="Nome do Vistoriador:", :required="false")
        el-input(
          disabled
          v-model="nomeVistoriador"
        )
      div.nome-vistoriador(v-if="isAlteracao")
        app-label(label="Justificativa:")
        el-input(type="textarea", v-model="justificativa")
      div.justify(v-if="exibirTermo")
        p Considerando que o Instituto de Terras do Pará – ITERPA, possibilitou a indicação de técnico devidamente habilitado junto ao CREA para realização de vistoria agronômica e, também, credenciado no ITERPA para tal finalidade após curso de formação nos termos do Edital 001/2021 do ITERPA publicado no DOE de 26 de outubro de 2021 com o rol dos profissionais habilitados. Pelo presente, venho INDICAR o(a) Sr(a). {{ nomeVistoriador }} como vistoriador do Processo Administrativo n° {{ processo.numeroProcesso }}.
      el-checkbox(v-if="exibirTermo", v-model="checkTermo") Li e concordo com o termo acima.
    template(slot="footer")
      .space-between
        el-button(@click="closeModal")
          i.end.fas.fa-times
          | Cancelar
        el-button(@click="vincular", :disabled="isBotaoConfirmarDisabled", type="primary")
          i.end.fas.fa-check
          | Confirmar
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import AppCabecalho from '@/components/AppCabecalho'
import AppPaginacao from '@/components/AppPaginacao'
import ListagemProcessosCredenciado from './ListagemProcessosCredenciado'
import SearchProcessos from '../processos/SearchProcessos'
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'

const emptyFiltro = {
  parametro: '',
  pagina: 1,
  simplificado: true,
  ordem: 'dataCadastro',
  ordemDirecao: 'DESC'
}

export default {
  components: {
    AppPaginacao,
    AppCabecalho,
    SearchProcessos,
    ListagemProcessosCredenciado,
    AppModal,
    AppLabel
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      totalProcessos: 0,
      isBusca: false,
      loading: false,
      filtro: _.cloneDeep(emptyFiltro),
      processos: [],
      processo: null,
      showModalVincular: false,
      isAlteracao: false,
      cpfVistoriador: '',
      exibirTermo: false,
      checkTermo: false,
      nomeVistoriador: '',
      idVistoriador: null,
      justificativa: '',
      isRemocao: false,
      tipoProcesso: ''
    }
  },

  async created () {
    this.carregaProcessos()
  },

  computed: {
    ...mapGetters({
      usuarioLogin: 'auth/usuarioLogado'
    }),
    isBotaoConfirmarDisabled () {
      return (this.isRemocao && !this.justificativa) ||
        (!this.isRemocao && !this.isAlteracao && !this.checkTermo) ||
        (this.isAlteracao && !this.isRemocao && (!this.justificativa || !this.checkTermo))
    }
  },

  methods: {
    ...mapActions({
      getProcessosByFilter: 'processos/getProcessosByFilter',
      findByUsuarioAndTipo: 'cadastro/findByUsuarioAndTipo',
      findVistoriadorExternoByCpfCnpj: 'usuario/findVistoriadorExternoByCpfCnpj',
      vincularVistoriadorCredenciado: 'subProcesso/vincularVistoriadorCredenciado'
    }),
    carregaProcessos () {
      this.clearFiltro()
      this.isBusca = false
      this.filtro.cpfCnpj = this.usuarioLogin.pessoa.cpfCnpj
      this.filtro.usuario = this.usuarioLogin.id

      this.findProcessos()
    },
    async findProcessos () {
      this.loading = true
      const result = await this.getProcessosByFilter(this.filtro)
      this.processos = result.processos
      this.totalProcessos = result.total
      this.loading = false
    },
    simpleSearchAsync:  _.debounce(function (filtro) { this.search(filtro); }, 700), // eslint-disable-line
    advancedSearchAsync: _.debounce(function (filtro) { this.advancedSearch(filtro); }, 700), // eslint-disable-line

    changePage (newPage) {
      this.filtro.pagina = newPage
      this.findProcessos()
    },

    sort (data) {
      this.isBusca = true
      this.filtro.pagina = 1
      this.filtro.ordem = data.ordenacao
      this.filtro.ordemDirecao = data.tipo

      this.findProcessos()
    },

    clear () {
      this.isBusca = false
      this.clearFiltro()

      this.carregaProcessos()
    },

    clearFiltro () {
      this.filtro = _.cloneDeep(emptyFiltro)
    },

    search (param) {
      this.isBusca = true
      this.filtro.parametro = param
      this.filtro.simplificado = true
      this.filtro.pagina = 1

      this.findProcessos()
    },

    advancedSearch (filtroAtualizado) {
      this.isBusca = true
      this.filtro.numeroProcesso = filtroAtualizado.numeroProcesso
      this.filtro.cpfCnpj = filtroAtualizado.cpfCnpj
      this.filtro.nomeRazaoSocial = filtroAtualizado.nomeRazaoSocial
      this.filtro.tipo = filtroAtualizado.tipo || null
      this.filtro.status = filtroAtualizado.status || null
      this.filtro.simplificado = false
      this.filtro.pagina = 1

      this.findProcessos()
    },
    goTo (data, setLoader, resetLoader) {
      setLoader()
      this.$router.push({
        name: 'detalhes-processo',
        params: {
          idCadastro: data.numeroProtocolo,
          numeroProcesso: data.numeroProcesso,
          id: data.id
        }
      }, () => {
        resetLoader()
      })
    },
    openModalVincular (processo) {
      this.showModalVincular = true
      this.processo = processo
    },
    async openModalAlteracao (processo) {
      this.showModalVincular = true
      this.isAlteracao = true
      this.processo = processo
      this.cpfVistoriador = processo.vistoriador.pessoa.cpfCnpj
      const data = await this.findVistoriadorExternoByCpfCnpj(this.cpfVistoriador)
      this.nomeVistoriador = data.pessoa.nomeRazaoSocial
      this.idVistoriador = data.id
      this.exibirTermo = true
    },
    closeModal () {
      this.showModalVincular = false
      this.cpfVistoriador = ''
      this.checkTermo = false
      this.nomeVistoriador = ''
      this.exibirTermo = false
      this.processo = null
      this.justificativa = ''
      this.isAlteracao = false
      this.isRemocao = false
      this.tipoProcesso = ''
    },
    async vincular () {
      await this.vincularVistoriadorCredenciado({
        numeroProcesso: this.processo.numeroProcesso,
        idVistoriador: this.idVistoriador,
        isAlteracao: this.isAlteracao,
        justificativa: this.justificativa,
        isRemocao: this.isRemocao,
        tipoProcesso: this.processo.tipo.codigo
      }).then(() => {
        this.showNotificacao(this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.isRemocao
            ? this.$messages.VISTORIADOR_CREDENCIADO_REMOVIDO
            : this.$messages.VISTORIADOR_CREDENCIADO_VINCULADO)
      })
      this.closeModal()
      this.findProcessos()
    },
    async findVistoriador () {
      if (this.cpfVistoriador.length === 14) {
        const data = await this.findVistoriadorExternoByCpfCnpj(this.cpfVistoriador)
        this.nomeVistoriador = data.pessoa.nomeRazaoSocial
        this.idVistoriador = data.id
        this.exibirTermo = true
        this.isRemocao = false
      }
      if (this.cpfVistoriador.length === 0) {
        this.nomeVistoriador = ''
        this.exibirTermo = false
        this.checkTermo = false
        if (this.isAlteracao) {
          this.isRemocao = true
        } else {
          this.processo = null
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

  .content-processos {
    flex: 1;
    padding: 20px;
  }

  .processos-header {
    display: inline-flex;
    align-items: start;
    padding: 10px 0;
  }

  .processos-main {
    padding: 10px 0;
  }

  .busca-processos {
    padding: 10px 0;
  }

  .listagem-processos {
    padding: 10px 0;
  }

  .nome-vistoriador{
    margin-top: 10px;

    p {
      color: $font-dark-color;
    }
  }

  .justify {
    text-align: justify;
    border: 1px solid $font-dark-color;
    border-radius: 4px;
    background: #8b93941f;
    padding: 10px;
    margin-bottom: 10px;
    margin-top: 20px;

    p {
      color: $font-dark-color;
    }
  }

  .space-between {
    display: flex;
    justify-content: space-between;
  }

  .end {
    margin-right: 5px;
  }

  @media (max-width: 780px) {
   .listagem-processos {
      position: relative;
      right: 10%;
      width: 31%;
   }

   .modalVistoriador {
    position: fixed !important;
    width: 375px !important;
   }

   .cardGeral {
    position: relative;
    top: 15px;
    right: 10%;
   }
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/credenciados/IncluirCredenciado.vue